import {Injectable} from '@angular/core';
import {ApiService} from "../api.service";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {Observable, of} from "rxjs";
import {OfferPeriod} from '@core/shared/models/offer/offer-period';

@Injectable({
    providedIn: 'root'
})
export class OfferPeriodService {

    constructor(
        private _apiService: ApiService,
        private _httpClient: HttpClient
    ) {
    }

    public createItemAPI(id: number, data: object): Observable<OfferPeriod> {

        const url = `${this._apiService.getApiUrl(false, true)}/offers/${id}/periods`;

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'text')
            .set('Accept', 'application/json');

        return this._httpClient.post<OfferPeriod>(url, data, {
            headers: headers
        });
    }

    public deleteItemAPI(id: number, data: object): Observable<OfferPeriod> {

        const url = `${this._apiService.getApiUrl(false, true)}/offers/${id}/periods/delete`;

        const headers: HttpHeaders = new HttpHeaders()
            .set('Content-Type', 'text')
            .set('Accept', 'application/json');

        return this._httpClient.post<OfferPeriod>(url, data, {
            headers: headers
        });
    }
}

